// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__pBAkP","info":"UpdateTermsInfo_info__3vrcq"};